import { useHandlers } from '../../../context/page-context';
import type { ProductsApiContract } from '../api';

export function useProductsApi(): { productsApi: ProductsApiContract } {
  const { apis } = useHandlers();
  return { productsApi: apis.products };
}
